import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatorService } from '../../../services/translate.service';
import { WorkflowService } from '../../../services/workflow.service';
import { LibService } from '../../../services/libService';

@Component({
    selector: 'app-bulk-setup-state-configuration-modal',
    templateUrl: './bulk-setup-state-configuration-modal.component.html',
    styleUrls: ['./bulk-setup-state-configuration-modal.component.scss']
})
export class BulkSetupStateConfigurationModal implements OnInit {

    confirmButtonLabel: any = 'LABEL.SAVE'
    cancelButtonLabel: any = 'LABEL.CANCEL'
    form: FormGroup
    workflows: any = []
    endWorkflows: any = []
    actions: any = []
    localData: any

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private translate: TranslatorService,
        private workflowService: WorkflowService,
        private libService: LibService,
    ) {
        let formStructure: any = {}

        formStructure['startWorkflow'] = [null, Validators.required]
        formStructure['action'] = [null, Validators.required]
        formStructure['endWorkflows'] = [null, Validators.required]

        if (data) {
            this.localData = data

            if (data.workflows) {
                this.workflows = data.workflows
            }

            this.form = this.fb.group(formStructure)
        }

    }

    getLabel(type: any) {

        switch (type) {
            case 'titleLabel':
                return this.translate.instant('LABEL.modificaResponsabileCommerciale');
            case 'textLabel':
                return '';
            default:
                break;
        }
        return '';
    }

    ngOnInit(): void {
    }

    disabledConfirmButton() {
        let disabled = false
        if (!this.form.valid) disabled = true
        return disabled
    }

    getLabelSelect(key: string) {
        let label = ''
        switch (key) {
            case 'startWorkflow':
                label = this.translate.instant('LABEL.startWorkflow');
                break;
            case 'action':
                label = this.translate.instant('LABEL.action');
                break;
            case 'endWorkflows':
                label = this.translate.instant('LABEL.endWorkflows');
                break;
        }
        return label
    }

    selectStartWorkflow(event: any) {
        console.log(event)

        let itemCategoryId = event?.itemCateroriesWorkflow?.ItemCategoryId
        this.endWorkflows = this.workflows.filter((workflow: any) => workflow?.itemCateroriesWorkflow?.ItemCategoryId == itemCategoryId)

        this.libService.lockPage('');
        this.workflowService.getActions(event.id).subscribe({
            next: (actions) => {
                this.actions = actions
                this.libService.unlockPage();
            },
            error: (err) => {
                console.log(err)
            }
        })
    
    }

    actionDisabled() {
        let startWorkflow = this.form?.get('startWorkflow')?.value
        return [null, undefined, ''].includes(startWorkflow) ? true : false
    }

    endWorkflowsDisabled() {
        let action = this.form?.get('action')?.value
        return [null, undefined, ''].includes(action) ? true : false
     }
}